import {Counter, TextInput} from '@/components-v2/molecules'
import {getDefaultQuantity} from '@/utils/productCombo/productComboValidation'
import {memo, useCallback} from 'react'

/**
 *   product: import('@/types/productComboTypes').ProductListingItem,
 *   onUpdateProductQuantity: (productId: string, quantity: number) => void,
 * }} props
 */
const ComboProductQuantityRowComponent = ({product, onUpdateProductQuantity}) => {
  const sellingUnits = getDefaultQuantity(product.multipleSellingUnits)

  const handleUpdateQuantity = useCallback(
    newValue => {
      const nextValue = Number(newValue)
      const currentQuantity = Number(product.quantity) || sellingUnits

      if (Number.isNaN(nextValue) || nextValue === currentQuantity) {
        return
      }

      const updatedQuantity =
        nextValue > currentQuantity
          ? currentQuantity + sellingUnits
          : Math.max(sellingUnits, currentQuantity - sellingUnits)

      onUpdateProductQuantity(product.productId, updatedQuantity)
    },
    [onUpdateProductQuantity, product.productId, product.quantity, sellingUnits]
  )

  return (
    <div className="flex items-center gap-6">
      <TextInput className="w-[300px]" label="Product Name" value={product.productName} disabled={true} />
      <div className="mb-2 w-[140px]">
        <Counter
          label="Quantity*"
          value={product.quantity}
          minValue={sellingUnits}
          maxValue={999}
          onUpdate={handleUpdateQuantity}
        />
      </div>
    </div>
  )
}

export const ComboProductQuantityRow = memo(ComboProductQuantityRowComponent)
